module.exports = __webpack_public_path__ + "public/img/empty.bd0a7269.svg";